import React from 'react';
import Navbar from './Navbar';
import {Link} from 'react-router-dom';
import LoginIcon from '../LoginIcon';
import './Header.less';
const logoImg = require('../../../images/logo1.png')

const Header = (props: any) => {
    const count = props.count ? props.count : 0;
    return (
        <header>
            <div className='site-nav wrap'>
                <span className='logo'>
                    <Link to='/skill-market'>
                        <div className={'header-logo'}><span className='span-left'>YonCodeHub</span></div>
                    </Link>
                </span>
                <Navbar {...props} />
                <div className='quick-menu'>
                    <LoginIcon />
                </div>
            </div>
        </header>
    );
};
export default Header;
